const utils = require('./utils');

/**
 * Scroll navigation to active item
 * @param {jQuery} $activeNav Active nav element
 * @param {boolean} animate true to animate the scroll
 */
function scrollToActiveItem($activeNav, animate = true) {
    if ($activeNav.length) {
        const activeNavPos = $activeNav[0].getBoundingClientRect();
        const sideNavContainer = document.querySelector('.listing');
        // always calculate the position based on current scroll pos
        const stopPos = sideNavContainer.scrollLeft + (activeNavPos.x - 30);
        // scroll the active nav item to the start position
        if (animate) {
            sideNavContainer.scroll({ left: stopPos, behavior: 'smooth' });
        } else {
            sideNavContainer.scrollTo(stopPos, 0);
        }
    }
}

/**
 * Initialized horizontal navigation behaviours
 */
function initializeHorizontalNavigation() {
    if (utils.getCurrentBreakpoint() === 'desktop') return;

    const $sideNavList = $('.sideNavHeadingText .listing');
    const $sideNavListItems = $('.listing-item', $sideNavList);
    const $sideNavActive = $('.active', $sideNavList);

    // update current nav item
    $sideNavListItems.on('click', (e) => {
        const $currentNav = $(e.currentTarget);
        $sideNavListItems.removeClass('active');
        $currentNav.addClass('active');
        scrollToActiveItem($currentNav);
    });

    // onload position of active nav item
    scrollToActiveItem($sideNavActive, false);
}
module.exports = () => {
    initializeHorizontalNavigation();
};
